import { h, Fragment } from 'preact';

import Header from '../../components/header';
import Footer from '../../components/footer';

import CustomHeight from '../../components/height/custom-height';
import ProfileTab from '../profile-tab';

const ProfileLayout = props => {
  return (
    <Fragment>
      <Header />
      <div class="container-xl">
        <CustomHeight height="48px" />

        {props.children}

        <CustomHeight height="48px" />
      </div>

      <Footer />
    </Fragment>
  );
};

export default ProfileLayout;
